import React,{useState, useEffect} from 'react'
import "./ImportFileformInputMatrixclientData.css"
import branch_icon from "../../../assets/register_assets/inputMatix/branch_icon.png"
import current_month_icon from "../../../assets/register_assets/inputMatix/current_month_icon.png"
import { useDispatch } from 'react-redux';
import { getClients} from './../../../services/global_redux/globale_actions/Client.action';
import { getInputMatrixActivities } from './../../../services/register_redux/register_actions/Form.action';
function ImportFileformInputMatrixclientData({date}) {
    const selectedClient = sessionStorage.getItem('selectedClient');
    const [clientIDs, setClientIDs] = useState(null);
    const [totalBranchCount,setTotalBranchCount] = useState(0);
    const dispatch = useDispatch();
    const fetchAllClient = async () => {
      try {
          const response = await dispatch(getClients());
          if (response.data) {
                setClientIDs(response.data);
          }
      } catch (err) {
          console.error("Failed to fetch clients:", err);
      }
  }
  
  useEffect(() => {
          fetchAllClient();
    }, [dispatch]);
    const getInputMatrixActivitiesFetch = async () => {
      try {
        const response = await dispatch(getInputMatrixActivities());
        if (response.success === true) {
          setTotalBranchCount(response.data.total_unit_count);
        }
      } catch (error) {
        console.error("Error:", error);
      }
    };
    
    useEffect(() => {
      getInputMatrixActivitiesFetch();
    }, [dispatch]);
  return (
    // <div className='ImportFileformInputMatrixclientData-main-data'>
    //     <div className="col-md-12">
    //     <h5>{clientIDs?.find(client => client.client_id === selectedClient)?.client_name}</h5>
    //     <p>Org. ID : {selectedClient}</p>
    //     <h6><img src={branch_icon} alt="Branch Icon" className="info-icon" />Branch</h6>
    //     <p>{date}</p>
    //     </div>
    // </div>
    <div className="container-fluid FormsImportFile-main-inputMatrix ">
      <div className="row">
        <div className="col-md-12">
          <div className="col-md-12">
            <div className="uploadFormsClientData">
              <div className="uploadFormsClientDataTitle">
                  <h5>{clientIDs?.find(client => client.client_id === selectedClient)?.client_name}</h5>
                  <p>Org. ID : {selectedClient}</p>
              </div>
              <div className="uploadFormsClientDataMonth d-flex gap-3">
                  <div className="d-flex align-items-center gap-2">
                      
                      <div>
                          <h6><img src={branch_icon} alt="Branch Icon" className="info-icon" />Branch</h6>
                          <p className='branch_data dataBorderDesign'>{totalBranchCount}</p>
                      </div>
                  </div>
                  <div className="vertical_line"></div>
                  <div className="d-flex align-items-center gap-2">
                      
                      <div>
                          <h6><img src={branch_icon} alt="Branch Icon" className="info-icon" />current Month</h6>
                          {/* {useMonths ?? <p className='current_month_data dataBorderDesign'>{new Date(useMonths)}</p>} */}
                          <button className='current_month_data dataBorderDesign'>{date ? new Date(date).toLocaleString('default', { month: 'long', year: 'numeric' }) : 'No Data Available'}</button>
                      </div>
                  </div>

              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  )
}

export default ImportFileformInputMatrixclientData